import { initialPlayerValues, buildPlayerCreationPayload, validatePlayerCreation } from './playerCreationForm'
export const tshirtSizes = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL']
// Older profiles store the size in lowercase ("m") or as "None", which the API refuses: open them as the listed
// size or as not provided, so saving an unrelated change does not force choosing a size.
const editableTshirtSize = value => {
  const size = typeof value === 'string' ? value.trim().toUpperCase() : ''
  return tshirtSizes.includes(size) ? size : ''
}
const place = location => location ? { city: location.city || '', country: location.country || '',
  name: location.name || location.city || '', coords: { lat: location.coords?.lat, lng: location.coords?.lng } } : null
// `suggestions.favoriteSport` comes from the API for a player who never chose a main sport.
export const initialPlayerEditValues = (profile, suggestions = {}) => {
  const organizer = profile.organizerInfo || {}
  return { ...initialPlayerValues(), ...Object.fromEntries(['firstName', 'lastName', 'email', 'phone', 'birthDate',
    'gender', 'dominantHand'].map(key => [key, profile[key] || ''])),
  favoriteSport: profile.favoriteSport || suggestions?.favoriteSport || '',
  birthDate: /^\d{4}-\d{2}-\d{2}(?:T|$)/.test(profile.birthDate || '') ? profile.birthDate.slice(0, 10) : '',
  tshirtSize: editableTshirtSize(profile.tShirtSize), country: profile.location?.country || '', location: place(profile.location),
  isOrganizer: profile.isOrganizer === true, organizerClientType: organizer.clientType || '',
  organizerFirstName: organizer.firstName || '', organizerLastName: organizer.lastName || '', organizerEmail: organizer.email || '',
  organizerPhone: organizer.phone || '', organizerCompany: organizer.companyName || '', organizerRegistrationNumber: organizer.uniqueRegistrationNumber || '',
  organizerCountry: organizer.location?.country || '', organizerLocation: place(organizer.location),
  organizerClubs: (organizer.assignedClubs || []).map(id => ({ value: id, label: id })),
  organizerOSAccess: organizer.osAccess === true ? 'true' : 'false',
  profileVisibility: profile.profileVisibility || '', profilePicture: profile.profilePicture || null,
  communicationPreferences: { ...profile.communicationPreferences },
  dailyLimit: profile.communicationPreferences?.dailyLimit ?? '',
  }
}
// The preferences the API lets an administrator edit (api `common/profileEditing` `preferenceFields`). The newsletters
// (`newsletter`, `newsletterTenis10`) and anything else the account stores are the player's own: never sent, or the API
// refuses the whole save (INVALID_PROFILE:communicationPreferences.<field>).
export const editablePreferenceFields = ['siteInbox', 'partnerMatches', 'playersTournaments', 'privateMessages',
  'dailyLimit', 'emailChatConversations', 'emailFriendRequests', 'emailFriendlyMatches', 'emailTournamentReviews']
export const buildPlayerEditPayload = values => {
  const { gameLevel, tshirtSize, ...profile } = buildPlayerCreationPayload(values)
  const communicationPreferences = Object.fromEntries(Object.entries(values.communicationPreferences || {})
    .filter(([field]) => editablePreferenceFields.includes(field)))
  if (values.dailyLimit !== '') communicationPreferences.dailyLimit = Number(values.dailyLimit)
  return { ...profile, tShirtSize: tshirtSize, communicationPreferences, profilePicture: values.profilePicture,
    ...(values.profileVisibility ? { profileVisibility: values.profileVisibility } : {}) }
}
// A birth date the player never gave may stay empty; a stored one stays required.
export const validatePlayerEdit = (values, settings, profile = {}) => {
  const errors = validatePlayerCreation(values, settings)
  if (!profile.birthDate && values.birthDate === '') delete errors.birthDate
  if (values.dailyLimit !== '' && (!Number.isSafeInteger(Number(values.dailyLimit)) || Number(values.dailyLimit) < 0)) errors.dailyLimit = 'Enter a nonnegative whole number.'
  return errors
}
